import * as React from 'react';
import { UsersLandingPage as UserPermissionsLandingPage } from './users-list';

export const UserPermissionsPage = () => {


    return (
        
            <UserPermissionsLandingPage />
            
    )
}
